/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Shots_DimensionsInputs */

const en_vc_shots_dimensions = /** @type {(inputs: Vc_Shots_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft Dimension tool measuring lengths, angles and radii`)
};

const zh_vc_shots_dimensions = /** @type {(inputs: Vc_Shots_DimensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 尺寸工具标注长度、角度和半径`)
};

/**
* | output |
* | --- |
* | "VectorCraft Dimension tool measuring lengths, angles and radii" |
*
* @param {Vc_Shots_DimensionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_shots_dimensions = /** @type {((inputs?: Vc_Shots_DimensionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Shots_DimensionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_shots_dimensions(inputs)
	return zh_vc_shots_dimensions(inputs)
});
export { vc_shots_dimensions as "vc.shots.dimensions" }